export const TEST_NAME = 'Test';
export const CURVES_NAME = 'Curva';
export const TEST_COLOR = '#99bfc7';
export const CURVES_COLOR = '#006072';
